import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { ProductColumnStructure } from "../../../Data/ProductManagement";
import { useProductRequest } from "../../../hooks/useProductRequest";
import { ProductRowType } from "../../../Types/ProductManagement";
import { UserModalDetailsType } from "../../../Types/UserManagement";
import { SearchTableButton } from "../../../utils/Constant";
import CommonModal from "../../atoms/Common/CommonModal";
import { YesNo } from "../../molecules/Forms/YesNo";
// import { demoServices } from "./Demodata";

export const ProductManagementContainer = () => {
  const { error, request, fetchRequests} = useProductRequest();
  const [filterText, setFilterText] = useState("");
  const [tableData, setTableData] = useState<ProductRowType[]>([]);
  const [loading, setLoading] = useState(false);
  const [modalDetails, setModalDetails] = useState<
    UserModalDetailsType | undefined
  >();

  useEffect(() => {
    if (request) setTableData(request);
    if (error) toast.error(error);
  }, [request, error]);

  const centeredToggle = () => {
    setModalDetails(undefined);
  };

  

  const refreshTable = async() => {
    setLoading(true)
    setTableData([])
    await fetchRequests(filterText)
    setLoading(false)
  }

  const subHeaderComponentMemo = useMemo(
    () => (
      <Row className="w-100 d-flex justify-content-between">
        <Col
          id="API-1_filter"
          className="w-50 dataTables_filter d-flex align-items-center justify-content-center "
        >
          <Label className="me-1">{SearchTableButton}:</Label>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            type="search"
            value={filterText}
            placeholder="Search by name or keywords"
          />
          <Button onClick={async() => await refreshTable()}>Search</Button>
        </Col>
        
        <Col className="w-50 d-flex justify-content-end">
          {/* <Btn
            color="primary"
            className="mb-3"
            onClick={() =>
              setModalDetails({ id: undefined, type: FormAccess.CREATE })
            }
          >
            {"Add Company"}
          </Btn> */}
          <Button onClick={async() => await refreshTable()}>{loading ? 'Loading...' : ' Refresh Table'}</Button>
        </Col>
      </Row>
    ),
    [filterText]
  );

  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <div className="table-responsive">
            <div id="API-1" className="dataTables_wrapper">
              <DataTable
                data={tableData}
                columns={ProductColumnStructure}
                striped={true}
                pagination
                className="display"
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            </div>
          </div>
          <CommonModal
            centered
            isOpen={modalDetails !== undefined}
            toggle={centeredToggle}
          >
            <div className="modal-toggle-wrapper">
              <YesNo
                centeredToggle={centeredToggle}
                onYesClick={() => {
                  console.log(modalDetails);
                }}
              />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};
